export default class Jwt {
  /**
   * @type {string} */
  issuer;

  /**
   * @type {string}
   */
  audience;

  /**
   * @type {number}
   */
  issuedAt;

  /**
   * @type {number}
   */
  expiration;

  /**
   * @type {string}
   */
  email;

  /**
   * @type {string}
   */
  phone;

  /**
   * @type {string}
   */
  username;

  /**
   * @type {string}
   */
  fullName;

  /**
   * @type {number}
   */
  userId;

  /**
   * @type {string}
   */
  token;

  constructor(opts = null) {
    if (opts != null) {
      if (opts.issuer != null) {
        this.issuer = opts.issuer;
      }
      if (opts.audience != null) {
        this.audience = opts.audience;
      }
      if (opts.issuedAt != null) {
        this.issuedAt = opts.issuedAt;
      }
      if (opts.expiration != null) {
        this.expiration = opts.expiration;
      }
      if (opts.email != null) {
        this.email = opts.email;
      }
      if (opts.phone != null) {
        this.phone = opts.phone;
      }
      if (opts.username != null) {
        this.username = opts.username;
      }
      if (opts.fullName != null) {
        this.fullName = opts.fullName;
      }
      if (opts.userId != null) {
        this.userId = opts.userId;
      }
      if (opts.token != null) {
        this.token = opts.token;
      }
    }
  }

  isExpired() {
    return new Date().getTime() / 1000 > this.expiration;
  }

  validate() {
    return this.userId != null;
  }
}
